import React from 'react';
import { Field } from 'formik';
import c from 'classnames';
import GenericFormElement from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/GenericFormElement';

function Checkbox(props) {
  const {
    name,
    value,
    validate,
    disabled,
    className,
    correct,
    someChecked,
  } = props;

  return (
    <Field required name={name} value={value} validate={validate}>
      {({ field, form }) => {
        const name = `${props.name}--${props.value}`;
        const checked = field.value && field.value.includes(value);
        const classes = c('WebformCheckboxes__checkbox__input', {
          'icon-before': true,
          'icon-checkmark': true,
          'icon-variant-1': checked,
          'correct': someChecked && correct,
          'disabled': someChecked,
        });

        if (props.value === '__other__') {
          const inputClasses = c({
            hidden: (!field.value.includes('__other__')),
          });

          return (
            <label className={classes} htmlFor={name}>
              <input
                {...field}
                name={props.name}
                value={value}
                type="checkbox"
                id={name}
                checked={checked}
                disabled={disabled || someChecked}
                className={className}
              />
              <span>
                <span>{props.otherLabel ? props.otherLabel : props.label}</span>
                { props.description && <span>{props.description}</span> }
              </span>
              <textarea
                placeholder={props.otherPlaceholder}
                className={inputClasses}
                onChange={(e) => {
                  form.setFieldValue(`${props.name}--other`, e.target.value);
                }}
              />
            </label>
          );
        }

        return (
          <label className={classes} htmlFor={name}>
            <input
              {...field}
              name={props.name}
              value={value}
              type="checkbox"
              id={name}
              checked={checked}
              disabled={disabled}
              className={className}
            />
            <span>
              <span>{props.label}</span>
              { props.description && <span>{props.description}</span> }
            </span>
          </label>
        );
      }}
    </Field>
  );
}

const Checkboxes = (props) => {
  const {
    title,
    required,
    description,
    placeholder,
    fieldName,
    validation,
    touched,
    error,
    type,
    options,
    descriptions = {},
    displayRequiredIndicator,
    className,
    wrapperClassName,
    disabled = false,
    otherLabel,
    otherPlaceholder,
    correctAnswers,
    someChecked,
  } = props;

  return (
    <GenericFormElement
      className={c('Checkboxes', wrapperClassName)}
      title={title}
      required={required}
      description={description}
      fieldName={fieldName}
      touched={touched}
      error={error}
      displayRequiredIndicator={displayRequiredIndicator}
    >
      {
        Object.keys(options).map((value) => {
          const label = options[value];
          const description = descriptions[value] || null;

          return (
            <Checkbox
              key={value}
              label={label}
              description={description}
              className={c(className, { 'error': error && touched })}
              name={fieldName}
              type={type || 'text'}
              value={value}
              placeholder={placeholder}
              validate={validation}
              disabled={disabled}
              otherLabel={otherLabel}
              otherPlaceholder={otherPlaceholder}
              correct={correctAnswers.includes(value)}
              someChecked={someChecked}
            />
          );
        })
      }
    </GenericFormElement>
  );
};

export default Checkboxes;
